export default __webpack_public_path__ + "static/media/logo.25d516d7.jpg";